import React, {
  Fragment,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Autocomplete from "@mui/material/Autocomplete";
import { AlertContext } from "../../../context/AlertContext";
import { ServiciosContext } from "../../../context/ServiciosContext";
import { ConfiguracionContext } from "../../../context/ConfiguracionContext";
import { ThemeProvider, createMuiTheme } from "@mui/material/styles";
import { makeStyles } from "@mui/material/styles";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import Spinner from "./../Spinner";
import { AuthContext } from "../../../context/AuthContext";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "../../../assets/css/DataTableDemo.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { Tag } from "primereact/tag";
import { InputText } from "primereact/inputtext";
import ButtonMui from "@mui/material/Button";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { saveAs } from "file-saver";
import Menu from "./../Menu";
import { InputNumber } from "primereact/inputnumber";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { InputMask } from "primereact/inputmask";
import IconButton from "@mui/material/IconButton";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { MultiSelect } from "primereact/multiselect";

const exportColumnsListado = [
  { title: "Cobrador", dataKey: "cobradorId" },
  { title: "Emitido", dataKey: "emitido" },
  { title: "Diferido", dataKey: "diferido" },
  { title: "Em + Dif", dataKey: "total1" },
  { title: "NC", dataKey: "nc" },
  { title: "Bajas", dataKey: "bajas" },
  { title: "Cobrado", dataKey: "cobrado" },
  { title: "NC + Baj + Cob", dataKey: "total2" },
  { title: "%", dataKey: "porcentaje" },
];

export default function EstadisticaCobradores(props) {
  const [globalFilter, setGlobalFilter] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const [visibleFechas, setVisibleFechas] = useState(true);
  const [fechas, setFechas] = useState(null);
  const [grupo, setGrupo] = useState(null);
  const [todasLasEmpresas, setTodasLasEmpresas] = useState(false);
  const [periodo, guardarPeriodo] = useState(null);
  const toast = useRef(null);
  const [selectedCities, setSelectedCities] = useState([]);

  let navigate = useNavigate();

  //Context

  const alertContext = useContext(AlertContext);
  const { mensajeAlerta } = alertContext;

  const authContext = useContext(AuthContext);
  const { state, usuarioAutenticado } = authContext;

  const configuracionContext = useContext(ConfiguracionContext);
  const {
    statusAcceso,
    empresas,
    estadisticaCobrador,
    empresaElegida,
    listadoExcel,
    obtenerAcceso,
    obtenerIvaVentas,
    obtenerEmpresas,
    obtenerEstadisticaCobrador,
  } = configuracionContext;

  useEffect(() => {
    if (state.usuario) {
      obtenerAcceso({
        usuarioId: state.usuario.id,
        layout: "EstadisticaCobradores",
      });
    }
  }, [state.id]);

  useEffect(() => {
    obtenerEmpresas();
  }, []);

  function formatDate(input) {
    var datePart = input.match(/\d+/g),
      year = datePart[0],
      month = datePart[1],
      day = datePart[2];
    return day + "/" + month + "/" + year;
  }

  const exitClick = (e) => {
    navigate("/");
  };

  const onHideFechas = (e) => {
    setVisibleFechas(false);
  };

  const aceptarFechas = async (exportType) => {
    //e.preventDefault();
    //Validar

    if (!periodo) {
      mensajeAlerta(
        "Estadística Cobradores",
        "Debe indicar período !.",
        "error"
      );
      return;
    }

    if (selectedCities && selectedCities.length === 0) {
      mensajeAlerta(
        "Estadística Cobradores",
        "Debe indicar una empresa !.",
        "error"
      );
      return;
    }

    var elem;

    toast.current.show({
      severity: "info",
      summary: "Listados",
      detail: "Obteniendo información... !",
      life: 3000,
    });

    await obtenerEstadisticaCobrador({
      periodo,
      selectedCities,
      exportType,
    }).then((data) => {
      if (exportType === "excel") {
        elem = document.getElementById("expButtonExcel");
        elem.click();
      }
      if (exportType === "pdf") {
        elem = document.getElementById("expButtonPdf");
        elem.click();
      }
    });
    /*
    onHideFechas();
    setGrupo(null);
    guardarVigencia({
      desde: null,
      hasta: null,
    });
    setIncluyeIntegrantes(false);
    setTodasLasEmpresas(false);
    */
  };

  const accesoDenegado = () => {
      mensajeAlerta(
        "Estadística de Cobradores",
        "No tiene permiso para acceder a esta pantalla !.",
        "error"
      );
    exitClick();
    return;
  };

  const renderHeaderFechas = () => {
    return (
      <div>
        <Tag
          value={"Estadística de Cobradores"}
        ></Tag>
      </div>
    );
  };

  const renderFooterFechas = () => {
    return (
      <div>
        <button
          id="expButtonExcel"
          type="button"
          onClick={(e) => {
            exportExcel();
          }}
          style={{ visibility: "hidden" }}
        >
          Export Excel
        </button>
        <button
          id="expButtonPdf"
          type="button"
          onClick={(e) => {
            exportPdf();
          }}
          style={{ visibility: "hidden" }}
        >
          Export Pdf
        </button>

        <Button
          icon="pi pi-file-excel"
          onClick={(e) => {
            aceptarFechas("excel");
          }}
          className="p-button-raised p-button-success"
          data-pr-tooltip="XLS"
          label="Excel"
        />
        <Button
          icon="pi pi-file-pdf"
          onClick={(e) => {
            aceptarFechas("pdf");
            //exportPdf();
          }}
          className="p-button-raised p-button-warning"
          data-pr-tooltip="PDF"
          style={{ marginRight: "1em" }}
          label="PDF"
        />
        <ButtonMui
          onClick={onHideFechas}
          color="secondary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CloseIcon />}
          autoFocus
        >
          Cancelar
        </ButtonMui>
      </div>
    );
  };

  const fechaTemplate = (rowData) => {
    return <Fragment>{formatDate(rowData.fecha)}</Fragment>;
  };

  const anuladoTemplate = (rowData) => {
    return (
      <Fragment>
        <Checkbox checked={rowData.anulado}></Checkbox>
      </Fragment>
    );
  };



  const exportExcel = () => {

    const arrayReordenado = estadisticaCobrador.map(objetoOriginal => {
  // 2. Crea un nuevo objeto para cada elemento, definiendo el orden de las propiedades
  return {
        cobradorId: objetoOriginal.cobradorId,
        emitido: objetoOriginal.emitido,
        diferido: objetoOriginal.diferido,
        total1: objetoOriginal.total1,
        nc: objetoOriginal.nc,
        bajas: objetoOriginal.bajas,
        cobrado: objetoOriginal.total1,
        total2: objetoOriginal.total2,
        porcentaje: objetoOriginal.porcentaje,
    // Si hay propiedades extras, puedes usar el spread syntax (...) para añadirlas al final
    ...objetoOriginal 
  };
});

    for (let i = 0; i < arrayReordenado.length; i++) {
      arrayReordenado[i].emitido = arrayReordenado[i].emitido.replaceAll(",","")
      arrayReordenado[i].diferido = arrayReordenado[i].diferido.replaceAll(",","")
      arrayReordenado[i].total1 = arrayReordenado[i].total1.replaceAll(",","")
      arrayReordenado[i].nc = arrayReordenado[i].nc.replaceAll(",","")
      arrayReordenado[i].bajas = arrayReordenado[i].bajas.replaceAll(",","")
      arrayReordenado[i].cobrado = arrayReordenado[i].cobrado.replaceAll(",","")
      arrayReordenado[i].total2 = arrayReordenado[i].total2.replaceAll(",","")
      arrayReordenado[i].emitido = parseFloat(arrayReordenado[i].emitido, 10);
      arrayReordenado[i].diferido = parseFloat(arrayReordenado[i].diferido, 10);
      arrayReordenado[i].total1 = parseFloat(arrayReordenado[i].total1, 10);
      arrayReordenado[i].nc = parseFloat(arrayReordenado[i].nc, 10);
      arrayReordenado[i].bajas = parseFloat(arrayReordenado[i].bajas, 10);
      arrayReordenado[i].cobrado = parseFloat(arrayReordenado[i].cobrado, 10);
      arrayReordenado[i].total2 = parseFloat(arrayReordenado[i].total2, 10);
    }

    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(arrayReordenado);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      saveAsExcelFile(excelBuffer, "estadisticaCobradores");
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((FileSaver) => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      return new Promise((resolve) => {
        saveAs(
          data,
          fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
        );
        resolve(true);
      });
    });
  };

  const exportPdf = () => {
    import("jspdf").then((jsPDF) => {
      import("jspdf-autotable").then(() => {
        const doc = new jsPDF.default("p");
        doc.setFontSize(10);

        let empresas = "";
        for (let i = 0; i < selectedCities.length; i++) {
          if (i === 0) {
            empresas = selectedCities[i].nombre;
          } else {
            empresas = empresas + " - " + selectedCities[i].nombre;
          }
        }

        doc.text(
          `Estadística de Cobradores Período: ${periodo} - Empresa: ${empresas} `,
          10,
          8
        );

        doc.autoTable(exportColumnsListado, estadisticaCobrador, {
          styles: {
            fontSize: 8,
          },
          columnStyles: {
            1: {
              halign: "right",
            },
            2: {
              halign: "right",
            },
            3: {
              halign: "right",
            },
            4: {
              halign: "right",
            },
            5: {
              halign: "right",
            },
            6: {
              halign: "right",
            },
            7: {
              halign: "right",
            },
            8: {
              halign: "right",
            },
          },
          didParseCell: (data) => {
            if (data.cell && data.cell.section === "head") {
              switch (data.cell.raw) {
                case "Cobrador":
                  data.cell.styles.halign = "left";
                  break;
                default:
                  data.cell.styles.halign = "right";
                  break;
              }
            }
          },
        });

        //doc.save("altasAfiliados.pdf");
        window.open(doc.output("bloburl"));
      });
    });
  };

  function formatDate(input) {
    var datePart = input.match(/\d+/g),
      year = datePart[0],
      month = datePart[1],
      day = datePart[2];
    return day + "/" + month + "/" + year;
  }

  function formatDateTime(dateString) {
    var allDate = dateString.replace("T", " ");
    allDate = allDate.replace(".", " ");
    allDate = allDate.split(" ");
    var thisDate = allDate[0].split("-");
    var thisTime = allDate[1].split(":");
    var newDate = [thisDate[2], thisDate[1], thisDate[0]].join("/");
    var newTime = [thisTime[0], thisTime[1]].join(":");
    return newDate + " " + newTime;
  }

  //console.log(estadisticaCobrador);
  //console.log(serviciosFinalizadosExcel);

  return (
    <Fragment>
      <Menu />
      <Toast ref={toast} />
      {statusAcceso === 0 ? <Spinner /> : null}
      {statusAcceso === 400 ? accesoDenegado() : null}
      {statusAcceso === 200 ? (
        <Fragment>
          <Dialog
            header={renderHeaderFechas()}
            visible={visibleFechas}
            closable={false}
            footer={renderFooterFechas()}
            breakpoints={{ "960px": "75vw" }}
            style={{ width: "70vw", paddingBottom: "0" }}
            position="top"
          >
            <Grid container spacing={3} style={{ marginTop: "1vw" }}>
              <Grid item xs={12} md={4}>
                <label htmlFor="periodo">Período</label>
                <InputMask
                  id="periodo"
                  mask="99/99"
                  value={periodo ? periodo : null}
                  placeholder="99/99"
                  //onBlur={handleEnter}
                  size={4}
                  onChange={(e) => guardarPeriodo(e.value)}
                  style={{ marginLeft: "0.7vw", marginTop: "0.4vw" }}
                ></InputMask>
              </Grid>

              <Grid
                item
                xs={12}
                md={12}
                style={{ paddingLeft: "1vw", marginTop: "1vw" }}
              >
                <label htmlFor="id">Empresas</label>

                <MultiSelect
                  value={selectedCities}
                  onChange={(e) => setSelectedCities(e.value)}
                  options={
                    empresas ? empresas.filter((item) => item.habilitado) : null
                  }
                  optionLabel="nombre"
                  placeholder="Seleccione las empresas"
                  maxSelectedLabels={10}
                  display="chip"
                  style={{ marginLeft: "1vw" }}
                  //className="w-full md:w-40rem"
                />
              </Grid>

              <Grid item xs={12} md={4} />

              {/*   
              <Grid
                item
                xs={6}
                md={3}
                style={{ paddingLeft: "1vw", marginTop: "1vw" }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      style={{ marginLeft: "1vw", marginRight: "1vw" }}
                      inputId="todasLasEmpresas"
                      onChange={(e) => {
                        setTodasLasEmpresas(e.target.checked);
                      }}
                      checked={todasLasEmpresas ? todasLasEmpresas : false}
                    />
                  }
                  label="Todas Las Empresas"
                />
              </Grid>
                */}
            </Grid>
          </Dialog>
        </Fragment>
      ) : null}
      <Grid item xs={12} sm={12}></Grid>
    </Fragment>
  );
}

/* class="MuiDataGrid-cell MuiDataGrid-cellLeft" */
